export enum ETransportValue {
  air = 'AIR',
  bus = 'BUS',
  self = 'SELF',
  dreamliner = 'dreamliner',
  dowolny = 'dowolny',
}
